export default __webpack_public_path__ + "static/media/3_Still.f28d18d8.jpg";